import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { SUPER_TOKEN_KEY } from '../../api/client';
import { ConsoleHelpLink } from '../console/help/ConsoleHelpLink';

function sideLinkStyle(isActive: boolean): React.CSSProperties {
  return {
    display: 'block',
    padding: '11px 18px',
    margin: '0 8px',
    borderRadius: 8,
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: isActive ? 600 : 500,
    color: isActive ? '#fff' : '#ddd6fe',
    background: isActive ? 'rgba(255,255,255,0.14)' : 'transparent',
    borderLeft: isActive ? '3px solid #c4b5fd' : '3px solid transparent',
    marginLeft: isActive ? 5 : 8,
    paddingLeft: isActive ? 15 : 18,
  };
}

export function SuperLayout() {
  const nav = useNavigate();
  const location = useLocation();
  const [hasToken, setHasToken] = useState(() =>
    typeof localStorage !== 'undefined' ? Boolean(localStorage.getItem(SUPER_TOKEN_KEY)) : false
  );

  useEffect(() => {
    setHasToken(Boolean(localStorage.getItem(SUPER_TOKEN_KEY)));
  }, [location.pathname]);

  const logout = () => {
    localStorage.removeItem(SUPER_TOKEN_KEY);
    setHasToken(false);
    nav('/super/login', { replace: true });
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
      <aside
        style={{
          width: 230,
          flexShrink: 0,
          background: 'linear-gradient(180deg, #1e1b4b 0%, #312e81 100%)',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          borderRight: '1px solid rgba(255,255,255,0.08)',
        }}
      >
        <div
          style={{
            padding: '18px 16px 14px',
            borderBottom: '1px solid rgba(255,255,255,0.12)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <img
              src="/logo.png"
              alt=""
              width={32}
              height={32}
              style={{ display: 'block', objectFit: 'contain', flexShrink: 0 }}
              aria-hidden
            />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: 0.06, color: '#c4b5fd', textTransform: 'uppercase' }}>
                Plataforma
              </div>
              <Link to="/super/orgs" style={{ color: '#fff', fontSize: 17, fontWeight: 700, textDecoration: 'none' }}>
                Super admin
              </Link>
            </div>
          </div>
        </div>

        <nav style={{ flex: 1, padding: '12px 0' }}>
          <NavLink to="/super/orgs" style={({ isActive }) => sideLinkStyle(isActive)}>
            Empresas
          </NavLink>
          <NavLink to="/super/demo-meetings" style={({ isActive }) => sideLinkStyle(isActive)}>
            Demos agendadas
          </NavLink>
          <NavLink to="/super/demo-usage" style={({ isActive }) => sideLinkStyle(isActive)}>
            Análisis demos
          </NavLink>
          <NavLink to="/super/wizard-agents" style={({ isActive }) => sideLinkStyle(isActive)}>
            Agentes Landing
          </NavLink>
          <NavLink to="/super/ai" style={({ isActive }) => sideLinkStyle(isActive)}>
            Modelos IA
          </NavLink>
        </nav>

        <div
          style={{
            padding: '12px 16px 20px',
            borderTop: '1px solid rgba(255,255,255,0.12)',
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          <Link
            to="/login"
            style={{
              display: 'block',
              textAlign: 'center',
              padding: '8px 10px',
              fontSize: 13,
              color: '#ddd6fe',
              textDecoration: 'none',
              border: '1px solid rgba(255,255,255,0.25)',
              borderRadius: 8,
            }}
          >
            Login de empresa
          </Link>
          {hasToken ? (
            <button
              type="button"
              onClick={logout}
              style={{
                padding: '9px 12px',
                borderRadius: 8,
                border: '1px solid rgba(248, 113, 113, 0.5)',
                background: 'rgba(127, 29, 29, 0.35)',
                color: '#fecaca',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Cerrar sesión plataforma
            </button>
          ) : null}
        </div>
      </aside>

      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', overflow: 'auto' }}>
        <div
          style={{
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 8,
            padding: '8px 16px',
            borderBottom: '1px solid #e2e8f0',
            background: '#fff',
          }}
        >
          <ConsoleHelpLink />
        </div>
        <Outlet />
      </div>
    </div>
  );
}
